import { useEffect, useContext } from 'react';

import { useGetAppConfigMutation } from '#services/app';
import { FeedbackUIContext } from '#context/feedback-ui-context';

export interface WebsiteFormState {
  wholesaleName: string;
  wholesaleUrl: string;
  wholesalePhone: string;
  contactEmail: string;
  logo: string;
  senderEmail: string;
  senderEmailPassword: string;
  senderName: string;
  orderEmailThreshold: string;
  shippingWindowInWeeks: number;
  shippingDelayInWeeks: number;
  shippingReminderThresholdDays: number;
  wearDateBufferDays: number;
  customizationConfirmDays: number;
  shippingDelayFrom: string;
  shippingDelayTo: string;
  announcement: string;
  [key: string]: unknown;
}

export const getInitialState = (plainData?: unknown): WebsiteFormState => {
  const initialState: WebsiteFormState = {
    wholesaleName: '',
    wholesaleUrl: '',

    wholesalePhone: '',
    contactEmail: '',
    logo: '',

    senderEmail: '',
    senderEmailPassword: '',
    senderName: '',
    orderEmailThreshold: '',

    shippingWindowInWeeks: 0,
    shippingDelayInWeeks: 0,
    shippingReminderThresholdDays: 10,
    wearDateBufferDays: 0,
    customizationConfirmDays: 5,
    shippingDelayFrom: new Date().toISOString(),
    shippingDelayTo: new Date().toISOString(),

    announcement: '',
  };

  // workaround for redux toolkit
  // TODO use redux to handle the state
  let state = plainData
    ? JSON.parse(JSON.stringify(plainData))
    : initialState;
  state = Object.assign({}, initialState, state);

  return state;
};

export function useData({
  resetForm,
}: {
  resetForm: (state: Record<string, unknown>) => void;
}) {
  const {
    showBackdrop,
    hideBackdrop,
  } = useContext(FeedbackUIContext)!;

  const [getAppConfig] = useGetAppConfigMutation();

  useEffect(() => {
    let isMounted = true;

    showBackdrop();
    void getAppConfig(undefined)
      .then((res) => {
        if (!isMounted) {
          return;
        }

        resetForm({
          ...res.data,
          loading: false,
        });
      }).finally(() => {
        if (isMounted) {
          hideBackdrop();
        }
      });

    return () => {
      isMounted = false;
      hideBackdrop();
    };
  }, []);
}
